var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 256 256",
    fill: "none",
    id: "my-svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient1"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stop1",
    offset: "0%",
    stopColor: "#8f66ff"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop2",
    offset: "100%",
    stopColor: "#3d12ff"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgr",
    width: 256,
    height: 256,
    fill: "none",
    rx: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 224L224 224M32 32L74.6667 32L74.6667 192H32V32ZM181.333 64L224 64L224 192L181.333 192L181.333 64ZM106.667 106.667L149.333 106.667L149.333 192H106.667L106.667 106.667Z",
    stroke: "#bfbfbf",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "my-path",
    transform: "translate(25.599999999999994,25.599999999999994) scale(0.8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResult);
export default __webpack_public_path__ + "static/media/result.a2abc4665d5a3cb8d0b62214eb664b20.svg";
export { ForwardRef as ReactComponent };